<mat-tab-group>
  <mat-tab label="{{ 'tabTradeHistory' | translate }}">
    <div class="table-responsive table-scroll-small">
      <table class="table table-bordered table-sm table-striped">
        <thead>
        <tr>
          <th scope="col" (click)="setOrder('timestamp')">{{ 'colTimestamp' | translate }}
            <i class="fa" [ngClass]="getClass('timestamp')"></i>
            </th>

          <th scope="col" (click)="setOrder('sixLetterCode')">{{ 'colInstrument' | translate }}
            <i class="fa" [ngClass]="getClass('sixLetterCode')"></i>
          </th>

          <th scope="col" (click)="setOrder('swapLeg')">{{ 'colSwapLeg' | translate }}
            <i class="fa" [ngClass]="getClass('swapLeg')"></i>
          </th>

          <th scope="col" (click)="setOrder('valueDate')">{{ 'colValueDate' | translate }}
            <i class="fa" [ngClass]="getClass('valueDate')"></i>
          </th>

          <th scope="col" (click)="setOrder('direction')">{{ 'colDir' | translate }}
            <i class="fa" [ngClass]="getClass('direction')"></i>
          </th>

          <th scope="col" (click)="setOrder('quantity')">{{ 'colQty' | translate }}
            <i class="fa" [ngClass]="getClass('quantity')"></i>
          </th>

          <th scope="col" (click)="setOrder('price')">{{ 'colPrice' | translate }}
            <i class="fa" [ngClass]="getClass('price')"></i>
          </th>

          <th scope="col" (click)="setOrder('swapPrice')">{{ 'colSwapPrice' | translate }}
            <i class="fa" [ngClass]="getClass('swapPrice')"></i>
            </th>

          <th scope="col" (click)="setOrder('swapRate')">{{ 'colSwapRate' | translate }}
            <i class="fa" [ngClass]="getClass('swapRate')"></i>
          </th>

          <th scope="col" (click)="setOrder('tradeId')">{{ 'colTradeID' | translate }}
            <i class="fa" [ngClass]="getClass('tradeId')"></i>
          </th>
        </tr>
        </thead>

        <tbody *ngIf="!TradeHistoryColumns || !TradeHistoryColumns.length">
        <tr *ngFor="let i of Arr(num).fill(1)"><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
        </tbody>

        <tbody *ngIf="TradeHistoryColumns && TradeHistoryColumns.length">
        <ng-container *ngFor="let column of TradeHistoryColumns | multiOrder: order, let i = index">

          <tr id="{{'TRADE_HISTORY_' + i}}">
            <td class="text-center" *ngIf="(column.timestamp | date:'yyyy') === (today | date: 'yyyy')">
              {{column.timestamp | date:'dd MMM - HH:mm:ss'}}
            </td>

            <td class="text-center" *ngIf="(column.timestamp | date:'yyyy') !== (today | date: 'yyyy')">
              {{column.timestamp | date:'dd MMM yyyy - HH:mm:ss'}}
            </td>

            <td class="text-center">{{currencyPairsJson[column.sixLetterCode].instrument.name}}</td>
            <td class="text-center">{{column.swapLeg}}</td>
            <td class="text-center">{{column.valueDate | date:'dd MMM yyyy':'GMT-4'}}</td>
            <td class="text-center">{{column.direction == 'LEND' ? 'SOLD' : 'BOUGHT'}}</td>
            <td>{{column.quantity | number:'1.2-2'}}</td>
            <td>{{column.price| number: getPriceNumberPipe(column)}}</td>
            <td>{{column.swapPrice | number:'1.0-12'}}</td>
            <td>{{column.swapRate | number:'1.2-2'}} {{column.swapRate ? '%' : ''}}</td>
            <td class="text-center">{{column.tradeId}}</td>
          </tr>

        </ng-container>

        </tbody>
      </table>
    </div><!-- responsive table END -->

  </mat-tab>


</mat-tab-group>
